// Scoped styles injected into the shadow root. Accent colour + corner come from config.

export function injectStyles(shadow, cfg) {
  const side = cfg.position === 'bottom-left' ? 'left: 20px;' : 'right: 20px;';
  const style = document.createElement('style');
  style.textContent = `
    :host, * { box-sizing: border-box; }
    .ff {
      --accent: ${cfg.accent};
      --bg: #ffffff;
      --fg: #1d1d24;
      --muted: #6b6b7b;
      --border: #ececf2;
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
      position: fixed; bottom: 20px; ${side}
      z-index: 2147483000;
    }

    /* Launcher pill */
    .ff-launcher {
      display: inline-flex; align-items: center; gap: 8px;
      padding: 11px 16px; border: none; border-radius: 999px;
      background: var(--accent); color: #fff; font-size: 14px; font-weight: 600;
      cursor: pointer; box-shadow: 0 6px 20px rgba(30,20,80,.22);
      transition: transform .12s ease, box-shadow .12s ease;
    }
    .ff-launcher:hover { transform: translateY(-1px); box-shadow: 0 10px 26px rgba(30,20,80,.28); }
    .ff-launcher:active { transform: translateY(0); }
    .ff-dot { width: 9px; height: 9px; border-radius: 50%; background: #fff; opacity: .9; }

    /* Card / popover */
    .ff-card {
      width: 320px; background: var(--bg); color: var(--fg);
      border: 1px solid var(--border); border-radius: 16px;
      box-shadow: 0 16px 48px rgba(20,16,60,.20);
      padding: 16px; animation: ff-pop .14s ease-out;
    }
    @keyframes ff-pop { from { opacity: 0; transform: translateY(8px) scale(.98); } to { opacity: 1; transform: none; } }

    .ff-card { position: relative; }
    .ff-title { font-size: 15px; font-weight: 700; margin: 0 0 2px; padding-right: 24px; }
    .ff-sub { font-size: 12.5px; color: var(--muted); margin: 0 0 14px; }

    /* Close (top-right of the card, pre-recording only) */
    .ff-x {
      position: absolute; top: 10px; right: 10px;
      width: 26px; height: 26px; border: none; border-radius: 8px;
      background: transparent; color: var(--muted);
      font-size: 18px; line-height: 1; cursor: pointer;
    }
    .ff-x:hover { background: #f0f0f6; color: var(--fg); }

    /* Start button: reads as a record button */
    .ff-btn-start { display: inline-flex; align-items: center; justify-content: center; gap: 8px; }
    .ff-start-dot { width: 10px; height: 10px; border-radius: 50%; background: #ff5c5c; box-shadow: 0 0 0 3px rgba(255,92,92,.28); }

    /* Stop icon inside the Stop & send button */
    .ff-stop-sq { display: inline-block; width: 9px; height: 9px; border-radius: 2px; background: #fff; margin-right: 7px; vertical-align: 0; }

    /* Waveform */
    .ff-wave { width: 100%; height: 56px; display: block; border-radius: 10px; background: #f6f6fb; }

    /* Recording header: red dot + timer */
    .ff-rec-head { display: flex; align-items: center; gap: 8px; margin-bottom: 10px; }
    .ff-rec-dot { width: 10px; height: 10px; border-radius: 50%; background: #e5484d; animation: ff-blink 1.1s ease-in-out infinite; }
    @keyframes ff-blink { 50% { opacity: .25; } }
    .ff-time { font-variant-numeric: tabular-nums; font-weight: 600; font-size: 14px; }
    .ff-time .ff-max { color: var(--muted); font-weight: 500; }

    /* Progress toward max duration */
    .ff-progress { height: 4px; border-radius: 4px; background: var(--border); margin: 12px 0 14px; overflow: hidden; }
    .ff-progress > span { display: block; height: 100%; width: 0%; background: var(--accent); transition: width .25s linear; }
    .ff-progress.ff-warn > span { background: #e8a13c; }
    .ff-warn-text { color: #b07514; }

    /* Optional consent line */
    .ff-consent { font-size: 11.5px; color: var(--muted); margin: 10px 0 0; }

    /* Buttons */
    .ff-row { display: flex; gap: 8px; }
    .ff-btn { flex: 1; padding: 10px 12px; border-radius: 10px; font-size: 13.5px; font-weight: 600; cursor: pointer; border: 1px solid var(--border); background: #fff; color: var(--fg); transition: background .12s ease, border-color .12s ease; }
    .ff-btn:hover { background: #f6f6fb; }
    .ff-btn:disabled { opacity: .5; cursor: default; pointer-events: none; }
    .ff-btn-primary { background: var(--accent); color: #fff; border-color: var(--accent); }
    .ff-btn-primary:hover { filter: brightness(1.05); background: var(--accent); }
    .ff-btn-danger { color: #c4332c; }
    .ff-btn-danger:hover { background: #fdf0ef; }
    .ff-btn-ghost { background: transparent; border-color: transparent; color: var(--muted); flex: 0 0 auto; padding: 10px; }
    .ff-icon-btn { flex: 0 0 auto; width: 40px; padding: 10px 0; }

    .ff-hidden { display: none !important; }

    /* Status (uploading / done / error) */
    .ff-status { display: flex; align-items: center; gap: 10px; font-size: 14px; }
    .ff-spinner { width: 16px; height: 16px; border: 2px solid var(--border); border-top-color: var(--accent); border-radius: 50%; animation: ff-spin .8s linear infinite; }
    @keyframes ff-spin { to { transform: rotate(360deg); } }
    .ff-ok { color: #2f9e44; font-weight: 600; }
    .ff-err { color: #c4332c; font-size: 13px; margin-bottom: 12px; }

    @media (prefers-reduced-motion: reduce) {
      .ff-rec-dot, .ff-spinner, .ff-card { animation: none; }
    }
  `;
  shadow.appendChild(style);
}
